import { render, staticRenderFns } from "./vehicleType.vue?vue&type=template&id=a2da2e2a&"
import script from "./vehicleType.vue?vue&type=script&lang=js&"
export * from "./vehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports